<template>
  <b-modal
    id="import-quickbooks"
    ref="import-quickbooks"
    size="lg-size"
    no-close-on-esc
    no-close-on-backdrop
    centered
    hide-footer
    hide-header
    @hide="close"
  >
    <div class="modal-head">
      <div class="title-wrap">
        <h2 class="modal-title">
          {{ label.get("quickbook_synchronize_your_team") }}
        </h2>
      </div>
      <div class="quickbooks-logo">
        <img
          src="/assets/images/quickbooks-logo.png"
          alt="Atto"
          class="black-logo"
          width="150"
          height="28"
        />
      </div>
    </div>
    <div
      class="content-wrapper quickbooks-container"
      :class="{ disclaimer: showResumeSubscription }"
    >
      <div
        v-if="showResumeSubscription"
        class="subscription-cancelled"
        :class="{ seats: showPurchaseSeats }"
      >
        <p class="disclaimer">
          {{
            label.get(
              "your_subscription_is_set_to_cancel_at_the_end_of_your_current_billing_period"
            )
          }}
        </p>
      </div>
      <div
        v-if="!showResumeSubscription"
        class="login-container signup-quickbooks synchronize-container"
      >
        <h4>
          {{ label.get("quickbook_add_your_quickooks_employees_to_atto") }}
        </h4>
        <div class="s-team-wrapper body-container">
          <div class="head-labels">
            <div class="label email">
              <p>
                {{ label.get("quickbook_employee_in_quickBooks") }}
              </p>
            </div>
            <div class="label">
              <p>
                {{ label.get("quickbook_match_to_employee_in_atto") }}
              </p>
            </div>
          </div>
          <ul class="quickbooks-member-list">
            <li v-for="(user, idx) in userWithoutEmail" :key="idx">
              <div class="field-row">
                <div class="check-wrapper">
                  <b-form-checkbox v-model="user.checked" :index="idx" />
                </div>
                <div class="member-name">
                  <p class="member-name">
                    {{ user.name }}
                  </p>
                </div>
                <div class="member-dropdown">
                  <div class="dropdown match">
                    <div class="role-wrap">
                      <select-dropdown-component
                        v-if="user.showDropdown"
                        v-model="user.user_id"
                        :index="idx"
                        placeholder="Select User:"
                        :options="companyUsers"
                        @onOptionSelected="onUserSelected"
                      />
                      <input
                        v-if="!user.showDropdown"
                        v-model="user.input_email"
                        type="text"
                        placeholder="Enter email"
                      />
                    </div>
                    <span class="invite-error-span" />
                  </div>
                  <div class="input-email hidden">
                    <span
                      v-if="user.duplicateDropdownError"
                      class="error-message"
                      >{{ label.get("you_have_duplicate_selections") }}</span
                    >
                    <span
                      v-if="user.duplicateEmailError"
                      class="error-message"
                      >{{ label.get("you_have_duplicate_emails") }}</span
                    >
                    <span v-if="user.validEmailError" class="error-message">{{
                      label.get("not_valid_email_address")
                    }}</span>
                    <span
                      v-if="user.selectOneItemError"
                      class="error-message"
                      >{{ label.get("please_select_one_user") }}</span
                    >
                    <span v-if="user.inputEmptyError" class="error-message">{{
                      label.get("please_provide_your_email_address")
                    }}</span>
                    <span v-if="user.backEndError" class="error-message">{{
                      user.backEndErrorMessage
                    }}</span>
                  </div>
                </div>
              </div>
            </li>
            <li v-for="(user, idx) in userToInvite" :key="`A-${idx}`">
              <div class="field-row">
                <div class="check-wrapper">
                  <b-form-checkbox v-model="user.checked" :index="idx" />
                </div>
                <div class="member-name">
                  <p class="member-name">
                    {{ user.name }}
                  </p>
                </div>
                <div class="member-dropdown">
                  <div class="input-email hidden">
                    <input
                      v-model="user.input_email"
                      placeholder="Enter email"
                    />
                    <span
                      v-if="user.duplicateEmailError"
                      class="error-message"
                      >{{ label.get("you_have_duplicate_emails") }}</span
                    >
                    <span v-if="user.validEmailError" class="error-message">{{
                      label.get("not_valid_email_address")
                    }}</span>
                    <span
                      v-if="user.selectOneItemError"
                      class="error-message"
                      >{{ label.get("please_select_one_user") }}</span
                    >
                    <span v-if="user.inputEmptyError" class="error-message">{{
                      label.get("email_is_required")
                    }}</span>
                    <span v-if="user.backEndError" class="error-message">{{
                      user.backEndErrorMessage
                    }}</span>
                  </div>
                </div>
              </div>
            </li>
            <li v-for="(user, idx) in matchUsers" :key="`B-${idx}`">
              <div class="field-row">
                <div class="check-wrapper">
                  <b-form-checkbox v-model="user.checked" :index="idx" />
                </div>
                <div class="member-name">
                  <p class="member-name">
                    {{ user.name }}
                  </p>
                </div>
                <div class="member-dropdown">
                  <div class="dropdown match">
                    <div class="role-wrap">
                      <select-dropdown-component
                        v-if="user.showDropdown"
                        v-model="user.user_id"
                        :index="idx"
                        placeholder="Select User:"
                        :options="companyUsers"
                        @onOptionSelected="onUserMatchSelected"
                      />
                      <input
                        v-if="!user.showDropdown"
                        v-model="user.input_email"
                        type="text"
                        placeholder="Enter email"
                      />
                    </div>
                  </div>
                  <div class="input-email hidden">
                    <span
                      v-if="user.duplicateDropdownError"
                      class="error-message"
                      >{{ label.get("you_have_duplicate_selections") }}</span
                    >
                    <span
                      v-if="user.duplicateEmailError"
                      class="error-message"
                      >{{ label.get("you_have_duplicate_emails") }}</span
                    >
                    <span v-if="user.validEmailError" class="error-message">{{
                      label.get("not_valid_email_address")
                    }}</span>
                    <span
                      v-if="user.selectOneItemError"
                      class="error-message"
                      >{{ label.get("please_select_one_user") }}</span
                    >
                    <span v-if="user.inputEmptyError" class="error-message">{{
                      label.get("email_is_required")
                    }}</span>
                    <span v-if="user.backEndError" class="error-message">{{
                      user.backEndErrorMessage
                    }}</span>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <p class="disclaimer">
          {{ label.get("quickbook_unchecked_employees_will_not_be_added") }}
        </p>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="reset"
        class="atto-btn cancel"
        data-dismiss="modal"
        @click="close"
      >
        {{ label.get("cancel") }}
      </button>
      <button
        v-if="!showResumeSubscription"
        class="atto-btn submit"
        type="submit"
        @click="submit"
      >
        {{ label.get("continue") }}
      </button>
      <button
        v-if="showResumeSubscription"
        type="submit"
        class="atto-btn submit"
        @click="reactivateSubscription"
      >
        {{ label.get("reactivate_subscription") }}
      </button>
    </div>
  </b-modal>
</template>

<script>
import CompanyService from "../services/CompanyService";
import SelectDropdownComponent from "../../../../shared/components/SelectDropdownComponent";

import InviteService from "../../../../shared/services/InviteService";
import BillingService from "../../billing/services/BillingService";

export default {
  name: "ImportQuickbooksComponent",
  components: {
    SelectDropdownComponent,
  },
  data() {
    return {
      companyUsers: [],
      matchUsers: [],
      userWithoutEmail: [],
      userToInvite: [],
      showPurchaseSeats: false,
      showNotAccountOwner: false,
      showResumeSubscription: false,
      purchaseSeats: 0,
      proratedCostPerUser: 0,
      isFirstPurchaseStripeTax: false,
      totalAmount: 0,
      discard: false,
      error: false,
      errorMessage: "",
      invalidEmails: false,
      invites: [
        {
          id: null,
          email: "",
          role: 3,
          error: false,
          sync_token: 0,
          employee_id: null,
        },
      ],
      roles: [
        {
          value: 1,
          label: this.label.get("admin"),
        },
        {
          value: 2,
          label: this.label.get("manager"),
        },
        {
          value: 3,
          label: this.label.get("employee"),
        },
      ],
    };
  },
  mounted() {
    document.body.appendChild(this.$el);
    this.$store.commit("showLoading");
    CompanyService.getQuickBookImportData()
      .then((result) => {
        if (result !== "") {
          this.seatsAvailable = result.seatsAvailable;
          this.onTrialPeriod = result.onTrialPeriod;
          this.onEndOfBillingCycle = result.onEndOfBillingCycle;

          this.userWithoutEmail = result.user_without_email.map(
            (item, index) => {
              item.input_email = null;
              item.employee_id = item.id;
              item.sync_token = 0;
              item.user_id = null;
              item.checked = true;
              item.showDropdown = true;
              item.index = index;
              item.userWithoutEmail = null;
              item.duplicateDropdownError = false;
              item.duplicateEmailError = false;
              item.validEmailError = false;
              item.inputEmptyError = false;
              item.dropdownType = null;
              item.backEndErrorMessage = "";
              item.backEndError = false;
              return item;
            }
          );

          this.userToInvite = result.userToInvite.map((item, index) => {
            item.input_email = item.email;
            item.employee_id = item.id;
            item.sync_token = 0;
            item.checked = true;
            item.index = index;
            item.userToInvite = null;
            item.showDropdown = false;
            item.duplicateDropdownError = false;
            item.duplicateEmailError = false;
            item.validEmailError = false;
            item.inputEmptyError = false;
            item.dropdownType = null;
            item.backEndErrorMessage = "";
            item.backEndError = false;
            return item;
          });

          this.matchUsers = result.matchUsers.map((item, index) => {
            item.name = item.quickbookUser.DisplayName;
            item.input_email = null;
            item.user_id = item.attoUser.id.toString();
            item.employee_id = item.quickbookUser.Id;
            item.sync_token = item.quickbookUser.SyncToken;
            item.checked = true;
            item.showDropdown = true;
            item.index = index;
            item.matchUsers = null;
            item.duplicateDropdownError = false;
            item.duplicateEmailError = false;
            item.validEmailError = false;
            item.inputEmptyError = false;
            item.backEndErrorMessage = "";
            item.backEndError = false;
            item.dropdownType = item.attoUser.email ? "invite" : "user";
            return item;
          });

          let users = [];
          $.each(result.companyUsers, function(key, value) {
            users.push({
              value: key,
              label: value,
            });
          });
          this.companyUsers = users.sort(function(a, b) {
            return a.value - b.value;
          });

          this.$refs["import-quickbooks"].show();
          this.$store.commit("hideLoading");
        } else {
          this.$store.commit("hideLoading");
          let query = Object.assign({}, this.$route.query);
          delete query.quickbook;
          this.$router.replace({ query });
          this.$awn.success(this.label.get("your_information_is_up_to_date"));
          this.$root.$emit("hideQuickBookImport");
        }
      })
      .catch((error) => {});
  },
  methods: {
    submit() {
      let members = [];
      let _this = this;
      let validModalForm = true;
      let role = "3";

      _this.userWithoutEmail.forEach((member) => {
        let entry = _this.userWithoutEmail[member.index];
        entry.duplicateDropdownError = false;
        entry.duplicateEmailError = false;
        entry.validEmailError = false;
        entry.selectOneItemError = false;
        entry.inputEmptyError = false;
        entry.backEndErrorMessage = "";
        entry.backEndError = false;
        _this.userWithoutEmail.splice(member.index, 1, entry);

        if (member.checked === true) {
          members.push(member);
        }
      });

      _this.userToInvite.forEach((member) => {
        let entry = _this.userToInvite[member.index];
        entry.duplicateDropdownError = false;
        entry.duplicateEmailError = false;
        entry.validEmailError = false;
        entry.selectOneItemError = false;
        entry.inputEmptyError = false;
        entry.backEndErrorMessage = "";
        entry.backEndError = false;
        _this.userToInvite.splice(member.index, 1, entry);
        if (member.checked === true) {
          members.push(member);
        }
      });

      _this.matchUsers.forEach((member) => {
        let entry = _this.matchUsers[member.index];
        entry.duplicateDropdownError = false;
        entry.duplicateEmailError = false;
        entry.validEmailError = false;
        entry.selectOneItemError = false;
        entry.inputEmptyError = false;
        entry.backEndErrorMessage = "";
        entry.backEndError = false;
        _this.matchUsers.splice(member.index, 1, entry);
        if (member.checked === true) {
          members.push(member);
        }
      });

      let usersThatMatch = [];
      let usersToInvite = [];
      // Check Duplicated Dropdown selected
      const seenDropDown = new Set();
      let AllDuplicatedDropdown = [];
      const seenEmail = new Set();
      let AllDuplicatedEmail = [];
      const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      members.filter((item) => {
        if (item.user_id) {
          const duplicateDropdown = seenDropDown.has(item.user_id);
          seenDropDown.add(item.user_id);
          if (duplicateDropdown) {
            AllDuplicatedDropdown.push(item);
          }
        }

        // Check Duplicated Emails in input
        if (item.input_email) {
          const duplicateEmail = seenEmail.has(item.input_email);
          seenEmail.add(item.input_email);
          if (duplicateEmail) {
            AllDuplicatedEmail.push(item);
          }
        }

        // check email validation
        if (
          item.input_email !== null &&
          item.input_email.trim() !== "" &&
          !regex.test(item.input_email.trim())
        ) {
          item.validEmailError = true;
          validModalForm = false;
        }

        // check if input is empty
        if (item.showDropdown === false && item.input_email === null) {
          item.inputEmptyError = true;
          validModalForm = false;
        }
        // check if any user is selected in dropdown
        if (item.showDropdown === true && item.user_id === null) {
          item.selectOneItemError = true;
          validModalForm = false;
        }

        // Matched user and invited user separate
        if (item.showDropdown === true && item.user_id !== null) {
          usersThatMatch.push({
            user_id: item.user_id,
            role: role,
            employee_id: item.employee_id,
            sync_token: item.sync_token,
            type: item.dropdownType,
          });
        }

        if (item.showDropdown === false && item.input_email !== null) {
          usersToInvite.push({
            email: item.input_email,
            role: role,
            employee_id: item.employee_id,
            sync_token: item.sync_token,
          });
        }
      });

      AllDuplicatedDropdown.forEach((item) => {
        if (
          item.userWithoutEmail !== undefined &&
          item.userWithoutEmail == null &&
          item.input_email === null
        ) {
          _this.userWithoutEmail[item.index].duplicateDropdownError = true;
          validModalForm = false;
        }
        if (
          item.userToInvite !== undefined &&
          item.userToInvite == null &&
          item.input_email === null
        ) {
          _this.userToInvite[item.index].duplicateDropdownError = true;
          validModalForm = false;
        }
        if (
          item.matchUsers !== undefined &&
          item.matchUsers == null &&
          item.input_email === null
        ) {
          _this.matchUsers[item.index].duplicateDropdownError = true;
          validModalForm = false;
        }
      });

      AllDuplicatedEmail.forEach((item) => {
        if (
          item.userWithoutEmail !== undefined &&
          item.userWithoutEmail == null
        ) {
          _this.userWithoutEmail[item.index].duplicateEmailError = true;
          validModalForm = false;
        }
        if (item.userToInvite !== undefined && item.userToInvite == null) {
          _this.userToInvite[item.index].duplicateEmailError = true;
          validModalForm = false;
        }
        if (item.matchUsers !== undefined && item.matchUsers == null) {
          _this.matchUsers[item.index].duplicateEmailError = true;
          validModalForm = false;
        }
      });

      // Send data to backend
      if (validModalForm) {
        if (usersThatMatch.length > 0) {
          CompanyService.quickBookMatchUsers(usersThatMatch)
            .then((response) => {
              let quickbookConnected = false;
              if (usersToInvite.length === 0) {
                const quickBooksParam = this.$route.query.quickbook;

                if (quickBooksParam !== undefined) {
                  quickbookConnected = true;
                }
              }

              this.$root.$emit("hideQuickBookImport", {
                quickbookConnected: quickbookConnected,
              });
              this.$awn.success(response.data.message);
            })
            .catch((error) => {
              // this.disabledDeactivateButton = false;
              // this.errorMessage = 'Error Disconnecting from QuickBooks Online';
            });
        }

        if (usersToInvite.length > 0) {
          //To Do call function for invite users

          const data = usersToInvite.map((item, idx) => {
            item.index = idx;
            return item;
          });

          InviteService.sendInvites({
            invites: data,
          })
            .then((result) => {
              if (result.status === 201) {
                this.purchaseSeats = result.data.purchaseSeats;
                this.isFirstPurchaseStripeTax = result.isFirstPurchaseStripeTax;
                this.proratedCostPerUser = result.data.proratedCostPerUser.toFixed(
                  2
                );
                this.totalAmount = (
                  this.purchaseSeats * this.proratedCostPerUser
                ).toFixed(2);

                this.invites = result.data.invites.map((item, idx) => {
                  item.index = idx;
                  item.deleting = false;
                  item.confirm_delete = false;
                  return item;
                });

                this.showPurchaseSeats = true;

                this.$root.$emit("hideQuickBookImport", {
                  showPurchaseSeats: true,
                  invites: this.invites,
                  proratedCostPerUser: parseFloat(this.proratedCostPerUser),
                  isFirstPurchaseStripeTax: this.isFirstPurchaseStripeTax
                });
              } else if (result.status === 210) {
                this.showResumeSubscription = true;
              } else {
                const quickBooksParam = this.$route.query.quickbook;
                let quickbookConnected = false;
                if (quickBooksParam !== undefined) {
                  quickbookConnected = true;
                }
                this.$root.$emit("hideQuickBookImport", {
                  quickbookConnected: quickbookConnected,
                });
                this.$awn.success(result.data.message);
              }
              this.$store.commit("hideLoading");
            })
            .catch((error) => {
              this.$store.commit("hideLoading");
              if (error.response.status === 422) {
                const errors = error.response.data;
                errors.forEach((err) => {
                  members.forEach((member) => {
                    if (
                      member.showDropdown === false &&
                      member.input_email === err.email
                    ) {
                      if (
                        member.userWithoutEmail !== undefined &&
                        member.userWithoutEmail == null
                      ) {
                        _this.userWithoutEmail[
                          member.index
                        ].backEndError = true;
                        _this.userWithoutEmail[
                          member.index
                        ].backEndErrorMessage = err.message;
                      }
                      if (
                        member.userToInvite !== undefined &&
                        member.userToInvite == null
                      ) {
                        _this.userToInvite[member.index].backEndError = true;
                        _this.userToInvite[member.index].backEndErrorMessage =
                          err.message;
                      }
                      if (
                        member.matchUsers !== undefined &&
                        member.matchUsers == null
                      ) {
                        _this.matchUsers[member.index].backEndError = true;
                        _this.matchUsers[member.index].backEndErrorMessage =
                          err.message;
                      }
                    }
                  });
                });
              } else if (error.response.status === 403) {
                this.$root.$emit("noSubscription");
              }
            });
        }

        if (usersThatMatch.length === 0 && usersToInvite.length === 0) {
          const quickBooksParam = this.$route.query.quickbook;
          let quickbookConnected = false;
          if (quickBooksParam !== undefined) {
            quickbookConnected = true;
          }
          this.$root.$emit("hideQuickBookImport", {
            quickbookConnected: quickbookConnected,
          });
        }
      }
    },
    close() {
      let quickbookConnected = false;
      const quickBooksParam = this.$route.query.quickbook;
      if (quickBooksParam !== undefined) {
        quickbookConnected = true;
      }
      this.$root.$emit("hideQuickBookImport", {
        quickbookConnected: quickbookConnected,
      });
    },
    reactivateSubscription() {
      this.$root.$emit("showReactivateSubscription");
    },
    onUserMatchSelected(option, index) {
      this.matchUsers[index].duplicateDropdownError = false;
      this.matchUsers[index].dropdownType = this.validateEmailInDropdown(
        option.label
      );
      if (option.value == "-0") {
        this.matchUsers[index].showDropdown = false;
      } else {
        this.matchUsers[index].user_id = option.value;
      }
    },
    onUserSelected(option, index) {
      this.userWithoutEmail[index].duplicateDropdownError = false;
      this.userWithoutEmail[index].dropdownType = this.validateEmailInDropdown(
        option.label
      );
      if (option.value == "-0") {
        this.userWithoutEmail[index].showDropdown = false;
      } else {
        this.userWithoutEmail[index].user_id = option.value;
      }
    },
    validateEmailInDropdown(email) {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email) === false ? "user" : "invite";
    },
  },
};
</script>

<style lang="scss">
.modal-entry-delete {
  .modal-content {
    .modal-body {
      .content-wrapper {
        &.password-confirm.has-error {
          padding-bottom: 16px;
        }
      }
    }
  }
}

.modal-lg-size {
  .modal-content {
    .modal-body {
      .modal-head {
        display: flex;
        flex-direction: row;

        h2.modal-title {
          margin-bottom: 4px;
        }

        .quickbooks-logo {
          margin-left: auto;
          display: inline-flex;
          align-items: center;
        }
      }

      .content-wrapper {
        display: flex;
        &.quickbooks-container {
          padding: 0 0 24px 0 !important;
          flex-direction: column;
        }

        h4 {
          font-weight: 400;
          font-size: 1rem;
          line-height: 1.25rem;
          margin-bottom: 16px;
          padding-left: 48px;
        }

        p.seats-desc {
          font-size: 0.75rem;
          line-height: 1rem;
          color: $atto-font-color;
          font-family: $roboto-font;
          font-weight: 400;
          margin-bottom: 16px !important;
        }

        .head-labels {
          display: flex;
          flex-direction: row;
          padding: 5px 12px 6px;
          margin: 0 48px;
          background: #fafafa;
          border: 1px solid #efefef;

          .label {
            display: inline-flex;
            width: 50%;

            p {
              font-size: 0.75rem;
              line-height: 1.5rem;
              color: $atto-dark-grey;
              font-family: $roboto-font;
              font-weight: 500;
              margin-bottom: 0;
            }
          }
        }

        .field-row {
          display: flex;
          flex-direction: row;
          margin-bottom: 0px !important;
          align-items: center;
          position: relative;
          width: 100%;

          p.member-name {
            font-size: 0.875rem;
            line-height: 1.25rem;
            color: $atto-font-color;
            font-family: $roboto-font;
            font-weight: 400;
            margin-bottom: 0px;
          }

          input {
            border: 2px solid $atto-light-grey;
            padding: 8px 12px;
            font-size: 0.875rem;
            line-height: 1.25rem;
            font-family: $roboto-font;
            font-weight: $roboto-regular;
            color: $atto-font-color;
            width: 100%;
            max-width: 360px;
            -webkit-appearance: none;
            border-radius: 0;
            @include base-transition(ease all 0.1s);

            &:focus {
              border-color: $atto-dark-grey;
            }
          }

          input.error {
            border: 2px solid $atto-red;
          }

          .checkbox-wrapper {
            margin-right: 16px;
            width: 24px;
          }

          .check-wrapper {
            .custom-checkbox {
              margin-left: 14px;
            }
          }

          .member-name {
            flex-grow: 1;
          }

          .member-dropdown {
            width: calc(50% - 16px);
          }

          .atto-select {
            margin-right: 0;

            .select-heading {
              width: 100%;
              max-width: 360px;
              flex-direction: row;
              @include base-transition(ease all 0.1s);

              span {
                flex-grow: 1;
                display: inline-flex;
              }

              i {
                @include base-transition(ease all 0.1s);
              }

              &:hover {
                border-color: #c7c7c7;

                i {
                  color: #c7c7c7;
                }
              }
            }

            .select-options {
              .heading {
                i {
                  margin-right: 0;
                  color: #c7c7c7;
                }
              }
            }
          }
        }

        ul.quickbooks-member-list {
          > li {
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 12px 48px 0 48px;
            flex-wrap: wrap;

            > *:not(&::after) {
              flex: 1;
            }

            /*border-bottom: 1px solid #efefef;*/

            &::after {
              content: "";
              display: inline-flex;
              width: 100%;
              height: 1px;
              background-color: #efefef;
              margin-top: 12px;
              margin-left: auto;
            }

            .check-wrapper {
              width: 40px;
            }

            .member-name {
              width: calc(50% - 40px);
            }
          }
        }

        p.disclaimer {
          padding-left: 50px;

          font-size: 0.875rem;
          line-height: 1.25rem;
          color: $atto-font-color;
          font-family: $roboto-font;
          font-weight: 500;
          margin-bottom: 0;
        }
      }
    }
  }
}

.password-confirm {
  p {
    margin-bottom: 12px !important;
    text-align: left !important;
  }

  input {
    width: 100%;
    border: 2px solid #efefef;
    padding: 5px 10px;
    font-family: "Roboto", sans-serif;
    line-height: 36px;
    color: #262626;

    &:focus {
      border-color: #00b9cb;
    }
  }
}
</style>
